import type { Zone } from '@seek/audience-zones';
import type { CompatibleLanguage } from '@seek/ca-myprofile-utils';
import type { Brand, Country, SiteName } from '@seek/melways-sites';

import { type PageAction, PageUpdateActionType } from './actionCreators';

export interface PageAnalytics {
  brand: Brand;
  siteCountry: Country;
  siteLanguage: CompatibleLanguage;
  zone: Zone;
  site: SiteName;
}

export interface PageState {
  pageAnalytics: PageAnalytics;
}

const initialState: PageState = {
  pageAnalytics: {
    brand: 'seek' as Brand,
    siteCountry: 'au' as Country,
    siteLanguage: 'en' as CompatibleLanguage,
    zone: 'anz-1',
    site: 'candidate-seek-au',
  },
};

export default function reducer(
  state = initialState,
  { type, payload }: PageAction,
): PageState {
  switch (type) {
    case PageUpdateActionType.SET_BRAND_COUNTRY_ZONE: {
      if (!payload) {
        return state;
      }
      return {
        ...state,
        pageAnalytics: {
          siteCountry: payload.siteCountry,
          siteLanguage: payload.siteLanguage,
          brand: payload.brand,
          zone: payload.zone,
          site: payload.site,
        },
      };
    }

    default:
      return state;
  }
}
